import { Box, Grid } from "@mui/material";
import { MainContext } from "common/interfaces/MainContext";
import React from "react";
import { NavigateFunction } from "react-router";
import { Info } from "../subComponents/Info";
import { Links } from "../subComponents/Links";
import { Logo } from "../subComponents/Logo";
import { Menu } from "../subComponents/Menu";
import styles from "./LargeHomePageContent.module.scss";

export const LargeHomePageContent = React.memo(
  (props: {
    mainContext: MainContext;
    estatesCount: number;
    navigate: NavigateFunction;
    onRequestInputDialogOpen: () => void;
  }) => {
    const { mainContext, navigate, onRequestInputDialogOpen, estatesCount } =
      props;

    return (
      <Grid container spacing={2}>
        <Grid size={4}>
          <Box className={styles.left}>
            <Logo styles={styles} />
            <Links
              styles={styles}
              navigate={navigate}
              mainContext={mainContext}
            />
          </Box>
        </Grid>
        <Grid size={8}>
          <Box className={styles.right}>
            <Info styles={styles} mainContext={mainContext} />
            <Menu
              styles={styles}
              navigate={navigate}
              onRequestInputDialogOpen={onRequestInputDialogOpen}
              estatesCount={estatesCount}
            />
          </Box>
        </Grid>
      </Grid>
    );
  }
);
